import { render } from "./CustomFormSelect.vue?vue&type=template&id=d19557e6"
import script from "./CustomFormSelect.vue?vue&type=script&lang=ts"
export * from "./CustomFormSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script